module.exports = __webpack_public_path__ + "assets/img/f2722639b7bd32f6d2ef911c2b00b144.svg";